// extracted by mini-css-extract-plugin
export default {"wrapper":"bq-z","response":"cq-z","error":"dq-z","disabled":"eq-z","buttons":"fq-z","feedbackQuestionSection":"gq-z","yesNoWrapper":"hq-z"};